<button
  type="button"
  class="tracking-back-button flex align-center justify-center"
  (click)="back()"
>
  <img src="icons/arrow-left.svg" />
</button>
<google-map
  [height]="'100%'"
  [width]="'100%'"
  [zoom]="12"
  [center]="center()"
  [options]="options"
  (mapInitialized)="onMapInitialized()"
>
  @for (marker of markers(); track $index) {
    <map-marker
      [position]="marker.position"
      [label]="marker.label ?? ''"
      [icon]="marker.icon"
      [options]="marker.options ?? {}"
      [title]="marker.title ?? ''"
    ></map-marker>
  }
</google-map>
